import React, {useContext} from "react";
import {Route, Redirect} from 'react-router-dom';
import AuthContext, {withAuthContextProvider, withAuthContextReady} from "../context/AuthContext";
import {compose} from "recompose";


const ProtectedUserRoute = ({component: Component, ...rest}) => {
    const {isAuth, idAuth} = useContext(AuthContext)
    return (
        <Route {...rest} render={props => (
            isAuth && idAuth ?
                <Component {...props} />
                : <Redirect to="/"/>
        )}/>
    );
};

export default compose(withAuthContextProvider, withAuthContextReady)(ProtectedUserRoute);
